import axios from 'axios';

const protocol = 'https';
const domain = 'annamor.art'
const URL = `${protocol}://${domain}`;

const mailScriptName = 'phpmail.php';

const config = {
   headers: {
    'Content-Type': 'application/json'
  }
}

export default {
  getPortfolioImages: () => {
    return axios.get(URL);
  },
  getMainSliderImages: () => {
    return axios.get(URL);
  },
  sendMail(body) {
    return axios.post(`${URL}/${mailScriptName}`, body, config);
  }
};
